import { useTranslation } from 'react-i18next';

function useGetTranslation(namespace: string = 'common') {
  // @ts-ignore
  const { t } = useTranslation(namespace);

  return {
    t,
  };
}

export default useGetTranslation;
